import { textStyles } from '../../bokeh/textStyles.js';

const bokehVariants = {
  "body-xl": {
    ...textStyles["body-xl"]
  },
  "body-lg": {
    ...textStyles["body-lg"]
  },
  "body-md": {
    ...textStyles["body-md"]
  },
  "body-sm": {
    ...textStyles["body-sm"]
  },
  "body-xs": {
    ...textStyles["body-xs"]
  },
  // There's no 3xl or 4xl in Iris, so we're using the header-1 styles for both
  "heading-4xl": {
    ...textStyles["heading-2xl"],
    fontWeight: "bold"
  },
  "heading-3xl": {
    ...textStyles["heading-2xl"],
    fontWeight: "bold"
  },
  "heading-2xl": {
    ...textStyles["heading-2xl"],
    fontWeight: "bold"
  },
  "heading-xl": {
    ...textStyles["heading-xl"],
    fontWeight: "bold"
  },
  "heading-lg": {
    ...textStyles["heading-lg"],
    fontWeight: "bold"
  },
  "heading-md": {
    ...textStyles["heading-md"],
    fontWeight: "bold"
  },
  "heading-sm": {
    ...textStyles["heading-sm"],
    fontWeight: "bold"
  },
  "heading-xs": {
    ...textStyles["heading-xs"],
    fontWeight: "bold"
  },
  "heading-2xs": {
    ...textStyles["heading-2xs"],
    fontWeight: "bold"
  }
};
const irisVariants = {
  "paragraph-1": {
    fontSize: "text",
    lineHeight: "paragraph",
    fontWeight: "regular",
    letterSpacing: ".01rem"
    // Iris
  },
  "paragraph-2": {
    fontSize: "text-sm",
    lineHeight: "text-lg",
    fontWeight: "regular",
    letterSpacing: ".01rem"
    // Iris
  },
  "paragraph-3": {
    fontSize: "text-xs",
    lineHeight: "text-sm",
    fontWeight: "regular",
    letterSpacing: ".01rem"
    // Iris
  },
  "paragraph-4": {
    fontSize: "0.6875rem",
    // Iris
    lineHeight: "text-xs",
    fontWeight: "regular",
    letterSpacing: ".01rem"
    // Iris
  },
  "header-1": {
    fontSize: "header-2xl",
    lineHeight: "header-2xl",
    fontWeight: "bold",
    letterSpacing: "-1.2px",
    // Iris
    fontFamily: "heading"
  },
  "header-2": {
    fontSize: "header-xl",
    lineHeight: "header-xl",
    fontWeight: "bold",
    letterSpacing: "-1px",
    // Iris
    fontFamily: "heading"
  },
  "header-3": {
    fontSize: "header-lg",
    lineHeight: "header-lg",
    fontWeight: "bold",
    letterSpacing: "-0.8px",
    // Iris
    fontFamily: "heading"
  },
  "header-4": {
    fontSize: "header",
    lineHeight: "header",
    fontWeight: "bold",
    letterSpacing: "-0.6px",
    // Iris
    fontFamily: "heading"
  },
  "header-5": {
    fontSize: "header-sm",
    lineHeight: "header-sm",
    fontWeight: "bold",
    letterSpacing: "-0.4px",
    // Iris
    fontFamily: "heading"
  },
  "header-6": {
    fontSize: "header-xs",
    lineHeight: "header-xs",
    fontWeight: "bold",
    letterSpacing: "-0.2px",
    // Iris
    fontFamily: "heading"
  },
  "header-7": {
    fontSize: "header-2xs",
    lineHeight: "header-2xs",
    fontWeight: "bold",
    letterSpacing: "0",
    // Iris
    fontFamily: "heading"
  }
};
let Text = {
  baseStyle: {
    margin: 0,
    fontSize: "text",
    lineHeight: "text",
    fontWeight: "regular",
    letterSpacing: "0.0125rem"
    // Iris
  },
  variants: {
    ...bokehVariants,
    ...irisVariants
  }
};

export { Text, irisVariants };
